<div class="component-container">
<div class="register-container">
    <h1>Create Account</h1>
    <form #form="ngForm" (ngSubmit)="register(form)">
        
        <div class="form-group">
            <label for="userName">Username</label>
            <input type="text" name="username" placeholder="Enter first name"
             ngModel autocomplete="off"
             required
             #userName="ngModel"
                >
                <div class="error-message" id="usernameError" [style.display]="(userName.invalid && (userName.dirty || userName.touched)) ? 'block' : 'none'">
                    <ul>
                        <li *ngIf="userName.errors?.['required']">Username is required</li>
                      </ul>
                </div>
        </div>
        
        <div class="form-group">
            <label for="email">Email</label>
            <input type="email" name="email" placeholder="Enter your email"
             #email="ngModel"
             ngModel 
             autocomplete="off" required     
             >
             <div class="error-message" id="emailError" [style.display]="(email.invalid && (email.dirty || email.touched)) ? 'block' : 'none'">
                <ul>
                    <li *ngIf="email.errors?.['required']">Email is required</li>
                  </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="password">Password</label>
            <div class="password-container">
                <input [type]="show ? 'text' : 'password'" name="password" placeholder="Create a password"
                 ngModel autocomplete="off" required
                 #credential="ngModel"
                 minlength="8"
                 pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
                 >
                <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggle()">Show</button>
            </div>

            <div class="error-message" id="passwordError" [style.display]="(credential.invalid && (credential.dirty || credential.touched)) ? 'block' : 'none'">
                <ul>
                    <li *ngIf="credential.errors?.['required']">Password is required</li>
                    <li *ngIf="credential.errors?.['minlength']">Must be at least 8 characters long</li>
                    <li *ngIf="credential.errors?.['pattern']">
                      Must include at least one uppercase letter, one number, and one special character
                    </li>
                  </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="password-container">
                <input [type]="show2 ? 'text' : 'password'" name="confirmPassword" placeholder="Confirm your password"
                 ngModel autocomplete="off" required
                 #confirmCredential="ngModel"
                 minlength="8"
                 pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
                 >
                <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggle2()">Show</button>
            </div>

            <div class="error-message" id="confirmPasswordError"  [style.display]="(confirmCredential.invalid && (confirmCredential.dirty || confirmCredential.touched)) ? 'block' : 'none'">
                <ul>
                    <li *ngIf="confirmCredential.errors?.['required']">Password is required</li>
                    <li *ngIf="confirmCredential.errors?.['minlength']">Must be at least 8 characters long</li>
                    <li *ngIf="confirmCredential.errors?.['pattern']">
                      Must include at least one uppercase letter, one number, and one special character
                    </li>
                  </ul>
            </div>
        </div>
        <div class="checkbox-container">
            <input type="checkbox" id="terms" required>
            <label for="terms">I agree to the <a [routerLink]="['/terms-of-service']" style="color: #7c4dff;">Terms of Service</a> and <a [routerLink]="['/privacy-policy']" style="color: #7c4dff;">Privacy Policy</a></label>
        </div>
        <button type="submit" class="btn" [disabled]="form.invalid">Register</button>
        <p class="login-link">Already have an account? <a [routerLink]="['/login']">Login</a></p>
    </form>
</div>
</div>